import React from 'react';
import Helmet from 'react-helmet';

const ProductSchema = ({
  data,
  templateData,
  schemaMinFare,
  source = '',
  dest = ''
}) => {
  const Name = !dest ? `${source} Cabs` : `${source} to ${dest} Cabs`;
  return (
    <Helmet>
      <script type="application/ld+json">
        {`
            {
                "@context": "https://schema.org",
                "@type": "Product",
                "name":"${Name}",
                "category":"Cab Services",
                "url":"${templateData?.sampleUrl}",
                "description":"${
                  templateData?.metaDescription
                    ? templateData?.metaDescription?.replace(/"/g, "'")
                    : ''
                }",
                "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "${data?.rating}",
                "reviewCount": "${data?.ratingCount}"
                },
                "audience": {
                "@type":"audience",
                "description":"${data?.ratingCount} Reviews",
                "audienceType" : "Customer"
                },
                "offers": {
                "@type": "AggregateOffer",
                "lowPrice": "${schemaMinFare}",
                "priceCurrency": "INR"
                }
            }
          `}
      </script>
    </Helmet>
  );
};

export default ProductSchema;
